import axios from 'lib/axios'

export interface ICertificationRegistrationPayload {
  client_code: string
  full_name: string
  email: string
  document: string
  job_title: string
  company: string
  phone: string
  accept_data_processing: boolean
  accept_methodology_ownership: boolean
}

const createCertificationRegistration = async (
  processId: number,
  payload: ICertificationRegistrationPayload,
) => {
  try {
    const response = await axios.post(
      `/certification-registration/process/${processId}`,
      payload,
    )
    return response.data
  } catch (error: any) {
    return {
      status: 'error',
      message: error?.response?.data?.message || 'Error al registrar la inscripción',
      error,
    }
  }
}

export default createCertificationRegistration
